import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getCinemaList } from '../../api/index';
import { getOrderCityTree } from '@/api/order';
export default {
  name: 'cinemaBlacklist',
  props: {
    module: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      query: {
        customer_id: '',
        customer_account_id: '',
        city_id: '',
        cinema_name: '',
        status: 0,
        start_discount: '',
        end_discount: '',
        page: 1
      },
      cityTree: [],
      city_id: '',
      whiteCinemaList: [],
      cinemaList: [],
      uploadFiledDialogShow: false,
      // 导入信息dialog
      dialogFileTitle: '',
      // 导入信息dialog title
      demoTitle: '',
      upTitle: '',
      tipsTitle: '',
      allCinema: [],
      isShow: false,
      pages1: {},
      pages2: {},
      checkedWhiteCinema: [],
      checkedCinema: [],
      cinemaPage1: {
        page: 1,
        page_size: 20
      },
      cinemaPage2: {
        page: 1,
        page_size: 20
      }
    };
  },
  created: function created() {
    // this.query.customer_id = this.$route.query.customer_id
    // this.query.customer_account_id = this.$route.query.customer_account_id
  },
  methods: {
    // 获取影院黑名单数据
    getWhiteCinemaData: function getWhiteCinemaData() {
      var _this = this;
      var params = _objectSpread(_objectSpread(_objectSpread({}, this.query), this.cinemaPage1), {}, {
        status: 1
      });
      params.city_id = this.city_id.length ? this.city_id[this.city_id.length - 1] : '';
      getCinemaList(this.module, params).then(function (res) {
        _this.whiteCinemaList = res.data;
        _this.pages1 = res.pages;
      });
    },
    // 获取底部影院表格数据
    getCinemaData: function getCinemaData(status) {
      var _this2 = this;
      var params = _objectSpread(_objectSpread(_objectSpread({}, this.query), this.cinemaPage2), {}, {
        status: 2
      });
      params.city_id = this.city_id.length ? this.city_id[this.city_id.length - 1] : '';
      getCinemaList(this.module, params).then(function (res) {
        _this2.cinemaList = res.data;
        _this2.pages2 = res.pages;
      });
    },
    getParentsById: function getParentsById(list, id) {
      for (var i in list) {
        if (list[i]['value'] == id) {
          return [list[i]['value']];
        }
        if (list[i].children) {
          var node = this.getParentsById(list[i].children, id);
          if (node !== undefined) {
            // 追加父节点
            node.unshift(list[i]['value']);
            return node;
          }
        }
      }
    },
    // 获取城市下拉框数据
    openWhiteCity: function openWhiteCity() {
      var _this3 = this;
      getOrderCityTree().then(function (res) {
        _this3.cityTree = JSON.parse(JSON.stringify(res.data.tree));
        var city_id = res.data.main_city;
        if (city_id) {
          _this3.city_id = _this3.getParentsById(_this3.cityTree, city_id);
        }
        _this3.searchCinema();
      });
    },
    // 获取影院下拉框数据
    openWhiteCinema: function openWhiteCinema() {
      var _this4 = this;
      var params = _objectSpread(_objectSpread({}, this.query), {}, {
        page_size: 20000
      });
      // 所有得影院数据用于筛选
      getCinemaList(this.module, params).then(function (res) {
        _this4.allCinema = res.data;
      });
    },
    searchCinema: function searchCinema() {
      this.getWhiteCinemaData();
      this.getCinemaData();
    },
    // 设置  (添加或移除) add 添加  del移除
    setBlackCinema: function (_setBlackCinema) {
      function setBlackCinema(_x) {
        return _setBlackCinema.apply(this, arguments);
      }
      setBlackCinema.toString = function () {
        return _setBlackCinema.toString();
      };
      return setBlackCinema;
    }(function (params) {
      var _this5 = this;
      setBlackCinema(params).then(function (res) {
        _this5.searchCinema();
        var tips = params.action === 'add' ? '添加成功' : '移除成功';
        _this5.$message.success(tips);
        _this5.$emit('changeCinema');
      });
    }),
    // 添加影院黑名单
    addWhiteCinema: function addWhiteCinema(row) {
      var _this6 = this;
      if (this.checkedCinema.length == 0) {
        this.$message.error('请选择影院');
        return false;
      }
      this.$confirm("\u662F\u5426\u5C06\u9009\u4E2D\u5F71\u9662\u6DFB\u52A0\u9ED1\u540D\u5355\uFF1F", '添加', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var ids = _this6.checkedCinema.map(function (i) {
          return i.standard_id;
        });
        var params = {
          customer_id: _this6.query.customer_id,
          customer_account_id: _this6.query.customer_account_id,
          standard_id: ids,
          action: 'add'
        };
        _this6.setBlackCinema(params);
      });
    },
    // 移除单个黑名单
    delWhiteCinema: function delWhiteCinema(row) {
      var _this7 = this;
      this.$confirm("\u662F\u5426\u5C06\u9009\u4E2D\u5F71\u9662\u79FB\u9664\u9ED1\u540D\u5355\uFF1F", '移除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var ids = _this7.checkedWhiteCinema.map(function (i) {
          return i.standard_id;
        });
        var params = {
          customer_id: _this7.query.customer_id,
          customer_account_id: _this7.query.customer_account_id,
          standard_id: ids,
          action: 'del'
        };
        _this7.setBlackCinema(params);
      });
    },
    // 移除所有黑名单
    delAllWhiteCinema: function delAllWhiteCinema() {
      var _this8 = this;
      this.$confirm("\u662F\u5426\u79FB\u9664\u6240\u6709\u9ED1\u540D\u5355\uFF1F", '移除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        var params = {
          customer_id: _this8.query.customer_id,
          customer_account_id: _this8.query.customer_account_id,
          standard_id: [],
          action: 'del'
        };
        _this8.setBlackCinema(params);
      });
    },
    handleChangeCinema: function handleChangeCinema(val, type) {
      if (type == 1) {
        this.checkedCinema = val;
      } else {
        this.checkedWhiteCinema = val;
      }
    },
    // 分页操作
    onChange: function onChange(val, flag) {
      if (flag === 1) {
        this.cinemaPage1.page = val;
        this.getWhiteCinemaData();
      } else if (flag === 2) {
        this.cinemaPage2.page = val;
        this.getCinemaData();
      }
    },
    sizeChange: function sizeChange(val, status) {
      if (status === 1) {
        this.cinemaPage1.page_size = val;
        this.getWhiteCinemaData();
      } else {
        this.cinemaPage2.page_size = val;
        this.getCinemaData();
      }
    },
    selectable: function selectable(row, index) {
      return row.disabled;
    }
  }
};